import { useEffect } from "react";
import { SOCIAL } from "@/siteConfig";

/**
 * Dynamically populates the Organization node's `sameAs` field inside the
 * Schema.org @graph in index.html whenever SOCIAL links are configured at
 * build time. Static JSON-LD ships with an empty sameAs; this runtime hook
 * keeps SEO up-to-date without requiring a redeploy of index.html when
 * adding LinkedIn or Twitter URLs later via siteConfig.
 */
export default function SocialSchema() {
  useEffect(() => {
    const sameAs = Object.values(SOCIAL).filter(Boolean);
    if (!sameAs.length) return;

    const node = document.head.querySelector(
      'script[type="application/ld+json"]'
    );
    if (!node) return;
    try {
      const data = JSON.parse(node.textContent);
      // Graph payload (current format): find Organization-like node and update sameAs.
      if (Array.isArray(data["@graph"])) {
        const org = data["@graph"].find((n) => {
          const t = n["@type"];
          return Array.isArray(t)
            ? t.includes("Organization")
            : t === "Organization" || t === "ProfessionalService";
        });
        if (org) {
          org.sameAs = sameAs;
          node.textContent = JSON.stringify(data);
        }
        return;
      }
      // Legacy fallback: flat Organization payload.
      if (Array.isArray(data.sameAs)) {
        data.sameAs = sameAs;
        node.textContent = JSON.stringify(data);
      }
    } catch (schemaErr) {
      if (process.env.NODE_ENV === "development") {
        console.warn("Failed to inject SOCIAL sameAs into JSON-LD:", schemaErr);
      }
    }
  }, []);

  return null;
}
